import redemptionsActions from 'models/Redemptions/actions'
import { FETCH_STATUSES } from 'resources'

export const initialState = {
  tremendousFetchStatus: FETCH_STATUSES.NOOP,
  cryptoFetchStatus: FETCH_STATUSES.NOOP,
  cryptoQuoteTokenFetchStatus: FETCH_STATUSES.NOOP,
  statuses: {},
  params: {},
  currency: null,
  cryptoOptions: [],
  tremendousOptions: [],
  cryptoQuoteToken: null,
}

const reducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case redemptionsActions.fetchTremendousRedemptionOptions.INIT_TYPE:
      return {
        ...state,
        tremendousFetchStatus: FETCH_STATUSES.FETCHING,
      }
    case redemptionsActions.fetchTremendousRedemptionOptions.SUCCESS_TYPE: {
      const { options, requirements } = payload
      return {
        ...state,
        tremendousFetchStatus: FETCH_STATUSES.SUCCESS,
        tremendousOptions: options,
        statuses: {
          hasNoRecentRedemptions: requirements.minRedemptionInterval.isValid,
          hasNoOpenRedemptions: requirements.noOpenRedemptions.isValid,
          hasMinAccountMaturity: requirements.minAccountMaturity.isValid,
          hasMinAccountBalance: requirements.minAccountBalance.isValid,
          hasEmail: requirements.verifiedEmail.isValid,
          hasNoMultipleAccounts: requirements.noMultipleAccountsOnSameDevice.isValid,
        },
        params: {
          remainingDaysAccountMaturity: requirements.minAccountMaturity.param,
          remainingDaysNextRedemption: requirements.minRedemptionInterval.param,
        },
      }
    }
    case redemptionsActions.fetchTremendousRedemptionOptions.FAILURE_TYPE: {
      return {
        ...state,
        tremendousFetchStatus: FETCH_STATUSES.FAILURE,
        statuses: {},
        params: {},
        tremendousOptions: [],
      }
    }
    case redemptionsActions.fetchCryptoRedemptionOptions.INIT_TYPE:
      return {
        ...state,
        cryptoFetchStatus: FETCH_STATUSES.FETCHING,
      }
    case redemptionsActions.fetchCryptoRedemptionOptions.SUCCESS_TYPE: {
      const { currency, options } = payload
      return {
        ...state,
        cryptoFetchStatus: FETCH_STATUSES.SUCCESS,
        currency,
        cryptoOptions: options,
      }
    }
    case redemptionsActions.fetchCryptoRedemptionOptions.FAILURE_TYPE: {
      return {
        ...state,
        cryptoFetchStatus: FETCH_STATUSES.FAILURE,
        currency: null,
        cryptoOptions: [],
      }
    }
    case redemptionsActions.requestCryptoRedemptionQuote.INIT_TYPE: {
      return {
        ...state,
        cryptoQuoteTokenFetchStatus: FETCH_STATUSES.FETCHING,
      }
    }
    case redemptionsActions.requestCryptoRedemptionQuote.SUCCESS_TYPE: {
      const { quoteToken } = payload
      return {
        ...state,
        cryptoQuoteTokenFetchStatus: FETCH_STATUSES.SUCCESS,
        cryptoQuoteToken: quoteToken,
      }
    }
    case redemptionsActions.requestCryptoRedemptionQuote.FAILURE_TYPE: {
      return {
        ...state,
        cryptoQuoteTokenFetchStatus: FETCH_STATUSES.FAILURE,
        cryptoQuoteToken: null,
      }
    }
    case redemptionsActions.clearCryptoRedemptionQuote.SUCCESS_TYPE: {
      return {
        ...state,
        cryptoQuoteTokenFetchStatus: FETCH_STATUSES.NOOP,
        cryptoQuoteToken: null,
      }
    }
    case 'RESET': {
      return initialState
    }
    default:
      return state
  }
}

export default reducer
